import React, { Fragment, memo, useState, useEffect, useRef } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply, faPlus, faPencilAlt, faTrash, faListAlt } from '@fortawesome/free-solid-svg-icons';
import { SiteRutas } from '../../../request/RutasConfig.jsx';
import Lista from '../../../components/UI/controlLista/controlLista.jsx';
import { Notificacion } from '../../../components/Util/Notificacion/Notificacion.jsx';
//Invocaciones datos
import { CentrosUtilidad_Listar_Request, CentrosUtilidad_Eliminar_Request } from "../../../request/MantenimientosRequest.jsx"

import { useSessionStorage } from '../../../components/Util/Hooks/useSessionStorage.jsx';
import ModalSpinner from '../../../components/UI/modalSpinner/modalSpinner.jsx';
import Swal from 'sweetalert2';


//Seguridad
import Session from '../../../components/Util/session/index.jsx';
import Config from '../../../components/Util/constantes.js';
import { Obtener_MenuOpciones_Lista_Request, Obtener_MenuNombre_Request } from "../../../request/MenuRequest.jsx"
import ModalSeguridad from "../../Seguridad/ModalSeguridad.jsx";
import optSeg from '../../../components/Util/seg-menu-opciones.js';
function listaCentroUtilidad(props) {

    const [borrando, setBorrando] = useState(false);
    const [datos, setDatos] = useState([]);
    const [id, setID] = useState(0);
    const [token, setToken] = useSessionStorage('tokenCON', '');
    const [usuario, setUsuario] = useSessionStorage('usuarioCON');
    const [empresa, setEmpresa] = useSessionStorage('empresaCON', 0);
    const mounted = useRef();
    const [spinnerModal, setSpinnerModal] = useState(undefined);
    const [spinnerLabel, setSpinnerLabel] = useState('');
    const [spinnerTipo, setSpinnerTipo] = useState(1);
    let historyMenu = useHistory();

    const columnas = [{
        dataField: 'ID',
        text: 'Código',
        csvText: 'codigo',
        sort: true
    }, {
        dataField: 'Nombre',
        text: 'Nombre',
        csvText: 'Nombre',
        sort: true
    }]
    const botones = [
        {
            name: "btnHomeC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => volverAtras(),
            leyenda: "",
            iclase: faReply,
            tooltip: "Volver"
        },
        {
            name: "btnModificarC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => actualizarDatos(),
            leyenda: "",
            iclase: faPencilAlt,//"fa fa-pencil",
            tooltip: "Modificar"
        },
        {
            name: "btnNuevoC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => ingresarDatos(),
            leyenda: "",
            iclase: faPlus,//"fa fa-plus",
            tooltip: "Agregar nuevo"
        },
        {
            name: "btnDeleteC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleBorrar(),
            leyenda: "",
            iclase: faTrash,
            tooltip: "Eliminar"
        },
    ]

    //Seguridad
    const [usuarioS, setUsuarioS] = useSessionStorage('UsuarioSCON');
    const [menuId, setMenuId] = useState(0);
    const [menuOpciones, setMenuOpciones] = useState([]);
    const [showModalSeguridad, setShowModalSeguridad] = useState(false);
    const [opcionValidar, setOpcionValidar] = useState(0);
    const [opcionValidarNombre, setOpcionValidarNombre] = useState('');



    const selectRow = { mode: 'radio', clickToSelect: true, hideSelectColumn: true, onSelect: (row, isSelected) => onRowSelect(row, isSelected), bgColor: '#d73220' };
    const spinnerModalMostrar = (pSpinnerModal, pSpinnerLabel, pSpinnerTipo) => {
        setSpinnerModal(pSpinnerModal);
        setSpinnerLabel(pSpinnerLabel);
        setSpinnerTipo(pSpinnerTipo);
    }

    const actualizarDatos = () => {
        if (validaSeleccionado()) {
            historyMenu.push(`${SiteRutas.MantCentroUtilidad}/${id}`);
        }
    }

    const ingresarDatos = () => {
        let _id = '0'
        historyMenu.push(`${SiteRutas.MantCentroUtilidad}/${_id}`);
    }

    const volverAtras = () => {
        historyMenu.push(SiteRutas.Asientos);
    }
    //Valida que se haya seleccionado un dato
    const validaSeleccionado = () => {
        let _id = id;
        if (_id != '') {
            return true;
        }
        else {
            Notificacion.error('Debe seleccionar un registro.');
            return false;
        }
    }
    const onRowSelect = (row, isSelected) => {
        setID(row.ID);
    }
    const onDoubleClick = (e, row, rowIndex) => {
        actualizarDatos();
    }

    const cargarDatos = async (pBorrando) => {
        if (!pBorrando) {
            let spinnerLabel = 'Cargando datos...';
            spinnerModalMostrar(true, spinnerLabel, 3)
        }
        const response = await CentrosUtilidad_Listar_Request(token, empresa);
        if (response.Exitoso) {
            setDatos(response.Datos);
        }
        else {
            Notificacion.error(response.Mensaje);
            spinnerModalMostrar(false, '', 3);
        }
        if (!pBorrando) {
            spinnerModalMostrar(false, '', 3)
        }


        const _MenuNomb = await cargarMenuNombre(Config.Modulo, optSeg.TMenuSistema.CentrosdeUtilidad.value);
        let _menuId = 0
        if (_MenuNomb.ID != undefined) {
            _menuId = _MenuNomb.ID;
        }
        const _UsuarioS = usuarioS;
        let _menuOpciones = null;
        if (_menuId > 0) {
            _menuOpciones = await cargarMenuOpciones(Config.Modulo, _UsuarioS, _menuId);
        }
        setMenuId(_menuId), setMenuOpciones(_menuOpciones)
    }



    const handleBorrar = () => {
        if (validaSeleccionado()) {
            const optSegopt = optSeg.TOpciones_Menu;
            let validar = validarMenuOpcion(optSegopt.Eliminar.value);
            if (!validar) {
                handleBorrarSel();
            }
        }
    }

    const handleBorrarSel = () => {
        let resultado = false;

        if (validaSeleccionado()) {

            Swal.fire({
                title: 'Eliminar Centro de Utilidad',
                html: '<h4>¿Está seguro que desea eliminar el centro de utilidad"?</h4>',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#10a599',
                cancelButtonColor: '#d33',
                confirmButtonText: '<h5><i class="fa fa-check fa-fw"></i> Sí</h5>',
                cancelButtonText: '<h5><i class="fa fa-remove fa-fw"></i> No</h5>',
                reverseButtons: true,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.value) {
                    resultado = true;
                    borrarDatos();
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    resultado = false;
                }
            })
            setBorrando(false);
        }

        return resultado;
    }



    const borrarDatos = async () => {
        let _id = id;
        let resultado = '';
        spinnerModalMostrar(true, 'Eliminando', 3);
        resultado = await CentrosUtilidad_Eliminar_Request(token,empresa, _id, usuario);
        if (resultado.Exitoso) {
            Notificacion.success(`Se eliminó con éxito.`);
            setBorrando(true);
            await cargarDatos(true);
            setID('');

        }
        else {
            Notificacion.error(`Error: ${resultado.Mensaje}`);
        }

        spinnerModalMostrar(false, '', 3);

    }

    useEffect(() => {

        if (!mounted.current) {
            const carga = async () => {
                await cargarDatos()
            }
            carga();
            mounted.current = true;
        }
    }, [])




    //Seguridad
    const cargarMenuOpciones = async (pModuloId, pUsuarioId, pMenuId) => {
        try {

            let listMO = await Obtener_MenuOpciones_Lista_Request(token, pModuloId, pUsuarioId, pMenuId);
            if (listMO.Exitoso === false) {
                return null;
            }
            return listMO.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuOpciones.`);
        }
    }

    const cargarMenuNombre = async (pModulo, pMenuNombre) => {
        try {
            let listMON = await Obtener_MenuNombre_Request(token, pModulo, pMenuNombre);
            if (listMON.Exitoso == false) {
                return null;
            }
            return listMON.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuNombre.`);
        }
    }

    const validarMenuOpcion = (pOpcion) => {
        let validar = false;
        let _menuOpciones = menuOpciones;
        const optSegopt = optSeg.TOpciones_Menu;
        let resultado = _menuOpciones.filter((item) => item.Opcion_Nombre == pOpcion);
        if (resultado.length > 0) {
            if (resultado[0].Opcion_Validar) {
                setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
                validar = true;
            }
        } else {
            setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
            validar = true;
        }
        return validar;
    };

    const handleCerrarModal = () => setShowModalSeguridad(false);

    const onActionResultModal = (pValido) => {
        if (pValido) {
            let _OpcionNom = opcionValidarNombre;
            setShowModalSeguridad(false); setOpcionValidar(0); setOpcionValidarNombre('');
            const _optSegopt = optSeg.TOpciones_Menu;
            switch (_OpcionNom) {
                case _optSegopt.Eliminar.value:
                    handleBorrarSel();
                    break;
                default:
                    break;
            }
        }
    }
  return (
    <Fragment>
    <Lista
        titulo={'Lista de Centros de Utilidad'}
        id={"ID"}
        datos={datos}
        columnas={columnas}
        selectRow={selectRow}
        onDoubleClick={onDoubleClick}
        borrando={borrando}
        botones={botones}
        verLHOC={false}
        nombreCSV={"CentroUtilidad"}
    />
    <ModalSpinner
        selectedModal={spinnerModal}
        contentLabel={'spinnerModalProgress'}
        label={spinnerLabel}
        tipoSpinner={spinnerTipo}
    />
    <ModalSeguridad
        modalTitle={'Requiere Permisos'}
        menuId={menuId}
        opcionId={opcionValidar}
        show={showModalSeguridad}
        onActionResult={onActionResultModal}
        onHide={handleCerrarModal}
    />

</Fragment>
  );
};
export default withRouter(memo(listaCentroUtilidad))
